<!-- eslint-disable no-new -->
<script setup lang="ts">
  import { Modal, Tooltip } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'

  import { ref, onMounted } from 'vue'

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  onMounted(() => {
    modal.value = new Modal('#modal-different-computer-error', {
      backdrop: 'static',
      keyboard: false,
    })
    new Tooltip('#extra-info', {
      title:
        'Para preservar a integridade e segurança do Certificado Digital A1, a chave privada é gerada e mantida na máquina original de instalação, não podendo ser reinstalada em outro dispositivo.',
      placement: 'top',
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  defineExpose({ show, hide })
</script>

<template>
  <div
    id="modal-different-computer-error"
    class="modal modal-md fade"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-3">
          <h5 class="modal-title">Atenção!</h5>

          <button
            class="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="hide"
          />
        </div>
        <div class="modal-body py-3">
          <img alt="sucesso" src="../assets/worried-girl.svg" />

          <p class="fs-6 text-start mt-4">
            Ops! Parece que
            <strong>você está usando um computador diferente</strong>
            do utilizado no início do processo de emissão.
            <icon-component id="extra-info" name="circle-question" />
          </p>

          <p class="fs-6 text-start mt-4">
            <strong>Acesse a página no computador correto</strong> para
            continuar a instalação do seu Certificado Digital.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-title {
    color: red;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 440px;
    }
  }
</style>
